import {styled} from 'leva/plugin'

export const DividerX = styled('div', {
  width: "1px", 
  minWidth: "1px",
  height: "50%",
  margin: "2px 0",
  backgroundColor: '$highlight1',
});
